module.exports = "p {\n    font-family: 'Helvetica Neue', Roboto, Arial, sans-serif !important;\n    font-size: 14px;\n    line-height: 1.5;\n}"